import { AuthActions, useAppDispatch } from "../../core/redux";
import { apiUrls } from "../../utils/apiUrls";
import loginImg from "../../assets/images/login-bg.png";
import { Input, InputGroup, Button, Checkbox, Loader } from "rsuite";
import EmailIcon from "@rsuite/icons/Email";
import { useState } from "react";
import EyeSlashIcon from "@rsuite/icons/Unvisible";
import EyeIcon from "@rsuite/icons/Visible";
import key from "../../assets/icons/key.svg";
import { postData } from "../../utils/reusables";

const Login = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const [forgotPass, setForgotPass] = useState(false);
  const [userName, setUserName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [showError, setShowError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [showLoader, setShowLoader] = useState<boolean>(false);

  const dataValidation = () => {
    const notEmpty = userName.length > 0 && password.length > 0;
    return notEmpty;
  };

  const handleChange = () => {
    setVisible(!visible);
  };

  const handleForgotPass = () => {
    setForgotPass(!forgotPass);
  };

  const dispatch = useAppDispatch();

  const login = () => {
    const payload = {
      userData: {
        Username: userName,
        Password: password,
      },
    };

    postData(apiUrls.auth.login, payload.userData).then((result) => {
      if (!result.data.succeeded) {
        setErrorMessage(result.data.message);
        setShowError(true);
        setShowLoader(false);
      }

      Object.assign(
        payload,
        { response: result.data.succeeded },
        { token: result.data.data.token }
      );

      dispatch(AuthActions.login(payload));
    });
  };

  return (
    <div className="custom-container container d-flex align-items-center justify-content-center ">
      <div className="row shadow login-border-radius">
        <div className="col-lg-6 col-md-6 col-12  px-0 d-lg-block d-sm-block d-none">
          <img src={loginImg} alt="" className="img-fluid" />
        </div>
        <div className="col-lg-6 col-md-6 col-12 px-0 py-5">
          <form className="d-flex flex-column px-4">
            <h2 className="d-flex justify-content-center mb-2 login-title">
              WTA Publisher
            </h2>
            <p className="d-flex justify-content-center mb-5 login-sub-title">
              Sign in to start your session
            </p>
            <div className="mb-2">
              <p className={!showError ? "d-none" : "text-danger pb-2"}>
                {errorMessage}
              </p>
              <InputGroup inside>
                <InputGroup.Addon>
                  <EmailIcon />
                </InputGroup.Addon>
                <Input
                  onChange={(value) => {
                    setUserName(value);
                    if (showError) {
                      setShowError(false);
                    }
                  }}
                  placeholder="User Id"
                />
              </InputGroup>
            </div>
            <div
              className={forgotPass ? "d-none" : "d-flex align-items-center"}
            >
              <InputGroup inside>
                <InputGroup.Addon>
                  <img src={key} alt="" />
                </InputGroup.Addon>
                <Input
                  onChange={(value) => {
                    setPassword(value);
                    if (showError) {
                      setShowError(false);
                    }
                  }}
                  type={visible ? "text" : "password"}
                  placeholder="Password"
                />
                <InputGroup.Button onClick={() => handleChange()}>
                  {visible ? <EyeIcon /> : <EyeSlashIcon />}
                </InputGroup.Button>
              </InputGroup>
            </div>
            <div className="d-flex my-2">
              <div
                className={
                  forgotPass ? "d-none" : "d-none d-flex align-items-center"
                }
              >
                <Checkbox className="login-text">Remember Me</Checkbox>
              </div>
              {!forgotPass ? (
                <Button
                  onClick={() => {
                    if (dataValidation()) {
                      setShowLoader(true);
                      login();
                    } else {
                      setErrorMessage(
                        "Please Enter Correct User ID and Password!"
                      );
                      setShowError(true);
                    }
                  }}
                  disabled={showLoader}
                  className="btn primary-color ms-auto d-inline-flex"
                >
                  {showLoader && <Loader className="my-auto pe-2" size="xs" />}{" "}
                  <span className="my-auto">Login</span>
                </Button>
              ) : (
                <Button className="btn primary-color ms-auto">Submit</Button>
              )}
            </div>
            <div className="ms-auto login-text forget-pass d-none">
              <p className="cursor-pointer" onClick={() => handleForgotPass()}>
                {forgotPass ? "Go back to login page" : "Forgot Password"}
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
